import { cn } from "@/lib/utils";

const sizes = {
  sm: "h-11 w-11",
  md: "h-[52px] w-[52px]",
  lg: "h-16 w-16",
};
const iconSize = { sm: 20, md: 24, lg: 28 };

const variants = {
  primary: "bg-primary text-primary-foreground shadow-glow hover:-translate-y-0.5",
  soft: "bg-accent text-accent-foreground hover:-translate-y-0.5",
  outline: "border-2 border-border text-foreground hover:border-primary hover:text-primary-strong",
  ghost: "text-foreground hover:bg-muted",
};

export function BloomIconButton({ icon: Icon, variant = "soft", size = "md", label, className, ...props }) {
  return (
    <button
      aria-label={label}
      className={cn(
        "inline-flex items-center justify-center rounded-full transition-all duration-200 ease-bounce active:scale-90 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ring/30 disabled:opacity-50 disabled:pointer-events-none",
        sizes[size],
        variants[variant],
        className,
      )}
      {...props}
    >
      <Icon size={iconSize[size]} weight="bold" />
    </button>
  );
}

export default BloomIconButton;
